export const sid = "foezikkztmieopihvzen";
export const environment = {
  production: true,
  supabaseUrl: 'https://' + sid + '.supabase.co',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZvZXppa2t6dG1pZW9waWh2emVuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1OTY2MDYsImV4cCI6MjA3MTE3MjYwNn0.5YI9AW6n5zXIRRZhxi64Y83DKWF28uIBUCnAmLMDjqI',
  vehicleVisualsUrlNoPartId: 'https://iqmotive.vehiclevisuals.com/thirdpartyapi/#!/viewAnimation/PARTNUMBERHERE?show_menu=0&is_interactive=0&show_left_sidebar=0&show_description=0&video_only=1&auto_play=0',
  SettingsExpiretime: 600000, // 10*60*1000 = 10 minutes
  logoUrl: 'http://localhost:8100/assets/LogoDarkBg.png',
  osbUrl: 'https://osb.release.serviceiqglobal.com',
  osbFrontendUrl: 'https://osb.release.serviceiqglobal.com',
  internalfileUrl: 'https://' + sid + '.supabase.co/storage/v1/object/public/internaldesign/',
  portalUrl: '',
};